import { MapPin, Navigation, Smartphone, Gift, Info } from "lucide-react"
import appStoreBadge from "../../assets/descargarApple.png"
import googlePlayBadge from "../../assets/descargarPlayStore.png"
import "../sections/DescargarSection.css"

export default function DescargarSection() {
  const appleStoreUrl = "https://apps.apple.com/ec/app/parkingclub/id6747083941"
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.parkinguser.parkingusers&hl=es_EC"

  return (
    <div className="descargar-section">
      <div className="descargar-container">
        <div className="info-banner-wrapper">
          <div className="info-banner-trigger">
            <Info className="info-trigger-icon" size={20} strokeWidth={2} />
          </div>
          <div className="info-banner">
            <Info className="info-banner-icon" size={24} strokeWidth={2} />
            <div className="info-banner-content">
              <p className="info-banner-text">
                <strong>App para usuarios:</strong> Esta es la aplicación para encontrar parqueaderos de nuestros
                socios.
              </p>
              <p className="info-banner-subtext">
                ¿Necesitas la app de control y gestión de parqueaderos?{" "}
              </p>
              <a href="#contactanos" className="info-banner-link">
                  Contáctanos aquí
                </a>
            </div>
          </div>
        </div>

        <div className="descargar-header">
          <div className="descargar-title-wrapper">
            <Smartphone className="descargar-title-icon" size={48} strokeWidth={1.5} />
            <h1 className="descargar-title">Descárgala ya</h1>
          </div>
          <p className="descargar-subtitle">Encuentra parqueaderos de forma fácil e intuitiva</p>
        </div>

        <div className="download-buttons-mobile">
          <a href={appleStoreUrl} target="_blank" rel="noopener noreferrer" className="download-image-link">
            <img src={appStoreBadge || "/placeholder.svg"} alt="Descargar en App Store" className="download-image" />
          </a>

          <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="download-image-link">
            <img
              src={googlePlayBadge || "/placeholder.svg"}
              alt="Descargar en Google Play"
              className="download-image"
            />
          </a>
        </div>

        <div className="descargar-content">
          <div className="qr-section">
            <div className="qr-card">
              <div className="qr-header">
                <h3 className="qr-title">iOS</h3>
              </div>
              <div className="qr-code-container">
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(appleStoreUrl)}`}
                  alt="QR Code para App Store"
                  className="qr-code"
                />
              </div>
              <p className="qr-description">Escanea para descargar en iPhone</p>
              <a href={appleStoreUrl} target="_blank" rel="noopener noreferrer" className="qr-link-desktop">
                <img
                  src={appStoreBadge || "/placeholder.svg"}
                  alt="Descargar en App Store"
                  className="qr-download-image"
                />
              </a>
            </div>

            <div className="qr-divider"></div>

            <div className="qr-card">
              <div className="qr-header">
                <h3 className="qr-title">Android</h3>
              </div>
              <div className="qr-code-container">
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(playStoreUrl)}`}
                  alt="QR Code para Google Play"
                  className="qr-code"
                />
              </div>
              <p className="qr-description">Escanea para descargar en Android</p>
              <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="qr-link-desktop">
                <img
                  src={googlePlayBadge || "/placeholder.svg"}
                  alt="Descargar en Google Play"
                  className="qr-download-image"
                />
              </a>
            </div>
          </div>

          <div className="descargar-info">
            <div className="info-card">
              <MapPin className="info-icon-lucide" size={48} strokeWidth={1.5} />
              <h4>Encuentra parqueaderos cerca</h4>
              <p>Localiza parqueaderos disponibles en tu zona de forma rápida</p>
            </div>
            <div className="info-card">
              <Navigation className="info-icon-lucide" size={48} strokeWidth={1.5} />
              <h4>Direcciones precisas</h4>
              <p>Obtén indicaciones exactas para llegar sin perder tiempo</p>
            </div>
            <div className="info-card">
              <Gift className="info-icon-lucide" size={48} strokeWidth={1.5} />
              <h4>Beneficios y promociones</h4>
              <p>Accede a descuentos exclusivos y ofertas especiales al descargar la app</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
